module.exports = __webpack_public_path__ + "4df195e86d091b90c13858458fb09a73.svg";